<div class="bcm-dash">

    <header class="bcm-topbar">
        <div class="bcm-identity">
            <h1>Club Manager</h1>
            <p>Contracts, collected fees and sales</p>
        </div>

        <div class="bcm-rangebar" *ngIf="periodLabel">
            <span class="bcm-chip">{{ periodName }}</span>
            <span class="bcm-rangebar-dates">{{ periodLabel }}</span>
            <span class="bcm-loadpip" *ngIf="loading" aria-hidden="true"></span>
        </div>

        <div class="bcm-progress" *ngIf="loading" role="progressbar"
             [attr.aria-valuenow]="loadProgress" aria-valuemin="0" aria-valuemax="100">
            <span class="bcm-progress-fill" [style.width.%]="loadProgress"></span>
        </div>
    </header>

    <div class="bcm-notice bcm-notice-error" *ngIf="errorMsg">
        <span class="bcm-notice-icon" aria-hidden="true">!</span>
        <p class="bcm-notice-body">
            <strong>This report could not load.</strong> {{ errorMsg }}
        </p>
    </div>

    <div class="bcm-notice bcm-notice-info" *ngIf="spillNoticeVisible">
        <span class="bcm-notice-icon" aria-hidden="true">i</span>
        <p class="bcm-notice-body">
            <strong>Last Month includes the 1st of this month.</strong>
            This reproduces the Power BI report's own date arithmetic, which is why the charts show a
            short extra bar for the current month. Set
            <code>AppSettings:BcmDashboardLastMonthIncludesFirstOfThisMonth</code> to
            <code>false</code> for a clean calendar month.
        </p>
    </div>

    <div class="bcm-grid">

        <section class="bcm-cell-cards" aria-label="Headline figures">

            <article class="bcm-stat bcm-stat-contracts" aria-labelledby="bcmStatContracts">
                <h2 class="bcm-stat-title" id="bcmStatContracts">Contracts</h2>
                <div class="bcm-stat-value">{{ contractsValue }}</div>
                <div class="bcm-stat-caption" *ngIf="periodLabel">{{ periodLabel }}</div>
            </article>

            <article class="bcm-stat bcm-stat-fees" aria-labelledby="bcmStatFees">
                <h2 class="bcm-stat-title" id="bcmStatFees">Fees Collected</h2>
                <div class="bcm-stat-value">{{ feesValue }}</div>
                <div class="bcm-stat-caption" *ngIf="periodLabel">{{ periodLabel }}</div>
            </article>

            <article class="bcm-stat bcm-stat-collected" aria-labelledby="bcmStatCollected">
                <h2 class="bcm-stat-title" id="bcmStatCollected">Collected Fees</h2>
                <div class="bcm-stat-value">{{ collectedTotal }}</div>
                <dl class="bcm-stat-details">
                    <div class="bcm-stat-detail">
                        <dt>Contracts</dt>
                        <dd>{{ collectedContracts }}</dd>
                    </div>
                    <div class="bcm-stat-detail">
                        <dt>Avg. per contract</dt>
                        <dd>{{ collectedAverage }}</dd>
                    </div>
                </dl>
            </article>

        </section>

        <section class="bcm-card" aria-labelledby="bcmSecAgent">
            <div class="bcm-card-head">
                <h2 id="bcmSecAgent">By Agent</h2>
            </div>
            <div class="bcm-card-body bcm-tablebody">
                <div class="bcm-scroll">
                    <table class="bcm-table">
                        <thead>
                            <tr>
                                <th scope="col">Agent</th>
                                <th scope="col" class="bcm-num">Contracts</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of byAgent; trackBy: trackByKey">
                                <th scope="row" [title]="row.label">{{ row.label }}</th>
                                <td class="bcm-num">{{ row.count }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <section class="bcm-card" aria-labelledby="bcmSecStatus">
            <div class="bcm-card-head">
                <h2 id="bcmSecStatus">By Contract Status</h2>
            </div>
            <div class="bcm-card-body bcm-tablebody">
                <div class="bcm-scroll">
                    <table class="bcm-table">
                        <thead>
                            <tr>
                                <th scope="col">Status</th>
                                <th scope="col" class="bcm-num">Contracts</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of byStatus; trackBy: trackByKey">
                                <th scope="row" [title]="row.label">{{ row.label }}</th>
                                <td class="bcm-num">{{ row.count }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <section class="bcm-card" aria-labelledby="bcmSecSite">
            <div class="bcm-card-head">
                <h2 id="bcmSecSite">By Site</h2>
            </div>
            <div class="bcm-card-body bcm-tablebody">
                <div class="bcm-scroll">
                    <table class="bcm-table">
                        <thead>
                            <tr>
                                <th scope="col">Site</th>
                                <th scope="col" class="bcm-num">Contracts</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of bySite; trackBy: trackByKey">
                                <th scope="row" [title]="row.label">{{ row.label }}</th>
                                <td class="bcm-num">{{ row.count }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </section>

        <section class="bcm-card" aria-labelledby="bcmSecMonthly">
            <div class="bcm-card-head">
                <h2 id="bcmSecMonthly">Monthly Fees</h2>
            </div>
            <div class="bcm-card-body bcm-chartbody">
                <kendo-chart [transitions]="false" [chartArea]="chartArea" *ngIf="monthlyFees.values.length">
                    <kendo-chart-tooltip [shared]="true" format="{0:c0}"></kendo-chart-tooltip>

                    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                    <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="monthlyFees.categories"
                                                       [labels]="monthlyAxisLabels"
                                                       [justified]="categoryAxisStyle.justified"
                                                       [majorGridLines]="categoryAxisStyle.majorGridLines"
                                                       [line]="categoryAxisStyle.line"></kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-value-axis>

                        <kendo-chart-value-axis-item [majorUnit]="monthlyValueAxis.majorUnit"
                                                     [title]="valueAxisTitle"
                                                     [labels]="monthlyValueAxis.labels"
                                                     [majorGridLines]="monthlyValueAxis.majorGridLines"
                                                     [minorGridLines]="monthlyValueAxis.minorGridLines"
                                                     [majorTicks]="monthlyValueAxis.majorTicks"
                                                     [line]="monthlyValueAxis.line"></kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-series>

                        <kendo-chart-series-item type="column" name="Fees"
                                                 [data]="monthlyFees.values" [color]="seriesColor"
                                                 [gap]="monthlyGap" [spacing]="0.25"
                                                 [labels]="monthlySeriesLabels"></kendo-chart-series-item>
                    </kendo-chart-series>
                </kendo-chart>

                <p class="bcm-empty" *ngIf="!monthlyFees.values.length && !loading">
                    No fees in the selected time frame.
                </p>
            </div>
        </section>

        <section class="bcm-card bcm-cell-wide" aria-labelledby="bcmSecSales">
            <div class="bcm-card-head">
                <h2 id="bcmSecSales">Total Sales</h2>

                <p class="bcm-cell-sub">{{ totalSalesSubtitle }}</p>
            </div>
            <div class="bcm-card-body bcm-chartbody">
                <kendo-chart [transitions]="false" [chartArea]="chartArea" *ngIf="totalSales.values.length">
                    <kendo-chart-tooltip [shared]="true" format="{0:c0}"></kendo-chart-tooltip>

                    <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                    <kendo-chart-category-axis>
                        <kendo-chart-category-axis-item [categories]="totalSales.categories"
                                                       [labels]="salesAxisLabels"
                                                       [justified]="categoryAxisStyle.justified"
                                                       [majorGridLines]="categoryAxisStyle.majorGridLines"
                                                       [line]="categoryAxisStyle.line"></kendo-chart-category-axis-item>
                    </kendo-chart-category-axis>
                    <kendo-chart-value-axis>

                        <kendo-chart-value-axis-item [majorUnit]="salesValueAxis.majorUnit"
                                                     [title]="valueAxisTitle"
                                                     [labels]="salesValueAxis.labels"
                                                     [majorGridLines]="salesValueAxis.majorGridLines"
                                                     [minorGridLines]="salesValueAxis.minorGridLines"
                                                     [majorTicks]="salesValueAxis.majorTicks"
                                                     [line]="salesValueAxis.line"></kendo-chart-value-axis-item>
                    </kendo-chart-value-axis>
                    <kendo-chart-series>

                        <kendo-chart-series-item type="area" name="Fees"
                                                 [data]="totalSales.values" [color]="seriesColor"
                                                 [opacity]="areaOpacity" [width]="2"
                                                 [markers]="markers"
                                                 [labels]="salesSeriesLabels"></kendo-chart-series-item>
                    </kendo-chart-series>
                </kendo-chart>

                <p class="bcm-empty" *ngIf="!totalSales.values.length && !loading">
                    No fees in the selected time frame.
                </p>
            </div>
        </section>
    </div>
</div>
